import _regeneratorRuntime from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import { a as _taggedTemplateLiteral, b as _objectSpread, c as _slicedToArray, d as _asyncToGenerator, e as _extends, f as _toConsumableArray } from './chunk-c961656f.js';
import styled, { css } from 'styled-components';
export { default as GlobalStyles } from './GlobalStyles.js';
import React, { useEffect, useState } from 'react';
import DataFrame from 'dataframe-js';
import Select from '@material-ui/core/Select';
import Input$1 from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import { DataSet, Network } from 'vis-network/standalone/esm/vis-network';
import { useDebounce } from 'use-debounce';
import { ResponsiveContainer, ScatterChart, CartesianGrid, XAxis, YAxis, ZAxis, Tooltip, Legend, Scatter } from 'recharts';
import MUIDataTable from 'mui-datatables';
import Link from '@material-ui/core/Link';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Grid$1 from '@material-ui/core/Grid';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import { Typography as Typography$1, Grid } from '@material-ui/core';

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.memo") : 60115,
      r = b ? Symbol.for("react.lazy") : 60116;

  function t(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case r:
        case q:
        case d:
          return u;
      }
    }
  }

  function v(a) {
    return t(a) === m;
  }

  exports.typeOf = t;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = r;
  exports.Memo = q;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || "object" === typeof a && null !== a && (a.$$typeof === r || a.$$typeof === q || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n);
  };

  exports.isAsyncMode = function (a) {
    return v(a) || t(a) === l;
  };

  exports.isConcurrentMode = v;

  exports.isContextConsumer = function (a) {
    return t(a) === k;
  };

  exports.isContextProvider = function (a) {
    return t(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return t(a) === n;
  };

  exports.isFragment = function (a) {
    return t(a) === e;
  };

  exports.isLazy = function (a) {
    return t(a) === r;
  };

  exports.isMemo = function (a) {
    return t(a) === q;
  };

  exports.isPortal = function (a) {
    return t(a) === d;
  };

  exports.isProfiler = function (a) {
    return t(a) === g;
  };

  exports.isStrictMode = function (a) {
    return t(a) === f;
  };

  exports.isSuspense = function (a) {
    return t(a) === p;
  };
});
unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;
var reactIs_development = createCommonjsModule(function (module, exports) {});
unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;
var reactIs = createCommonjsModule(function (module) {
  {
    module.exports = reactIs_production_min;
  }
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var has = Function.call.bind(Object.prototype.hasOwnProperty);

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});
var colors = {
  primary: {
    border: '#dfe1e5',
    blue: '#1a0dab',
    variant1: 'rgb(0,163,210)'
  },
  font: {
    main: '0000',
    primary: '#ffff',
    tableHead: 'rgb(98,107,120)',
    subtitle: '#777',
    list: 'rgb(76,165, 245)'
  },
  defaultArray: ['#eba844', '#d62711', '#297ceb', '#FFFF99', '#00B3E6', '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D', '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC', '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399', '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933', '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
};

var getColor = function getColor(name, array) {
  var colorsArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : colors.defaultArray;
  return colorsArray[array.indexOf(name)];
};

var RDFTypes = {
  s: 's',
  relatedCompaniesName: 'relatedCompaniesName',
  type: 'type',
  an: 'AN'
};
var urlRegexp = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/;

var toFirstUpperCase = function toFirstUpperCase(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
};

var toNiceWebsiteFormat = function toNiceWebsiteFormat(website) {
  return website.split('.').slice(1).join('.');
};

var getDataFrame = function getDataFrame(processedResults) {
  var cols = processedResults.head.vars;
  var out = [];
  processedResults.results.bindings.forEach(function (row) {
    var item = [];
    cols.forEach(function (c) {
      var val = row[c];

      if (!val) {
        item.push(c);
      } else {
        item.push(val.value);
      }
    });
    out.push(item);
  });
  return new DataFrame(out, cols);
};

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em 1em;\n  border-left: 3px solid ", ";\n  height: 2em;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  text-decoration: none;\n  color: black;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: 16px;\n  background-color: ", ";\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 1em;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0.5em 0 0 0;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  font-weight: bold;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em 3em;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n\n  :hover {\n    background-color: rgba(245, 245, 245);\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  font-size: 1.25em;\n  font-size: 1.25em;\n  display: flex;\n  padding: 0 2.3em 1em 2.3em;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 500px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.div(_templateObject());
var Heading = styled.th(_templateObject2(), function (props) {
  return props.color;
});
var Table = styled.table(_templateObject3());
var Row = styled.tr(_templateObject4(), function (props) {
  return props.color;
}, function (props) {
  return props.isActive ? 'rgba(245, 245, 245)' : null;
});
var Data = styled.td(_templateObject5());
var SignalType = styled.div(_templateObject6());
var Bubbles = styled.ul(_templateObject7());
var Bubble = styled.li(_templateObject8(), function (props) {
  return props.color;
});
var Headline = styled.a(_templateObject9(), function (props) {
  return props.color;
});
var BubbleTable = {
  Container: Container,
  Heading: Heading,
  Table: Table,
  Row: Row,
  SignalType: SignalType,
  Bubbles: Bubbles,
  Bubble: Bubble,
  Data: Data,
  Headline: Headline
};
var type = RDFTypes.type,
    relatedCompaniesName = RDFTypes.relatedCompaniesName;

function BubbleTableComponent(_ref) {
  var tableTitleColor = _ref.tableTitleColor,
      listColor = _ref.listColor,
      selectedOptions = _ref.selectedOptions,
      setSelectedOptions = _ref.setSelectedOptions,
      bubbles = _ref.bubbles,
      tableCollection = _ref.tableCollection,
      rdfObj = _ref.rdfObj,
      colors = _ref.colors,
      title = _ref.title,
      groupBySelector = _ref.groupBySelector,
      bubbleSelector = _ref.bubbleSelector;
  var df = rdfObj ? getDataFrame(rdfObj) : null;

  var getTableCollection = function getTableCollection() {
    if (tableCollection && !rdfObj) return tableCollection;
    return df.select(groupBySelector, bubbleSelector).groupBy(groupBySelector) // TODO: Evaluate if removing duplicates should be an option
    .aggregate(function (d) {
      return d.dropDuplicates(bubbleSelector);
    }).toCollection();
  };

  var getBubbles = function getBubbles() {
    if (bubbles && !rdfObj) return bubbles;
    return df.groupBy(bubbleSelector).listGroups().map(function (t) {
      return t[bubbleSelector];
    });
  };

  var table = getTableCollection();
  var bubblesArray = getBubbles();
  return React.createElement(BubbleTable.Container, null, React.createElement(BubbleTable.Table, null, React.createElement("thead", null, React.createElement("tr", null, React.createElement(BubbleTable.Heading, {
    color: tableTitleColor
  }, title))), React.createElement("tbody", null, table.map(function (obj) {
    return React.createElement(BubbleTable.Row, {
      color: listColor,
      isActive: selectedOptions.includes(obj[groupBySelector])
    }, React.createElement(BubbleTable.Data, {
      onClick: function onClick() {
        return setSelectedOptions([obj[groupBySelector]]);
      }
    }, React.createElement(BubbleTable.SignalType, null, obj[groupBySelector]), React.createElement(BubbleTable.Bubbles, null, obj.aggregation.toCollection().map(function (c) {
      return React.createElement(BubbleTable.Bubble, {
        key: c[bubbleSelector],
        color: getColor(c[bubbleSelector], bubblesArray, colors)
      });
    }))));
  }))));
}

BubbleTableComponent.propTypes = {
  listColor: propTypes.string,
  tableTitleColor: propTypes.string,
  colors: propTypes.arrayOf(propTypes.string),
  rdfObj: propTypes.shape({
    head: propTypes.shape({
      vars: propTypes.arrayOf(propTypes.string)
    }),
    results: propTypes.shape({
      bindings: propTypes.arrayOf(propTypes.object)
    })
  }),
  selectedOptions: propTypes.arrayOf(propTypes.string),
  title: propTypes.string,
  bubbleSelector: propTypes.string,
  groupBySelector: propTypes.string,
  setSelectedOptions: propTypes.func,
  // TODO: custom prop validation
  tableCollection: propTypes.arrayOf(propTypes.obj),
  bubbles: propTypes.arrayOf(propTypes.string)
};
BubbleTableComponent.defaultProps = {
  listColor: colors.font.list,
  tableTitleColor: colors.font.tableHead,
  colors: colors.defaultArray,
  rdfObj: null,
  selectedOptions: [],
  title: null,
  bubbleSelector: relatedCompaniesName,
  groupBySelector: type,
  setSelectedOptions: function setSelectedOptions() {},
  tableCollection: null,
  bubbles: null
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  background-color: #44a2d0;\n  border-radius: 5px;\n  color: white;\n  cursor: pointer;\n  padding: 0.5em;\n\n  :focus {\n    outline: 0;\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var StyledButton = styled.button(_templateObject$1());

var Button = function Button(_ref) {
  var onClick = _ref.onClick;
  return React.createElement(StyledButton, {
    type: "button",
    onClick: onClick
  }, "Hello");
};

Button.propTypes = {
  onClick: propTypes.func.isRequired
};

function _templateObject9$1() {
  var data = _taggedTemplateLiteral(["\n  list-style: none;\n  padding: 0;\n\n  li {\n    margin-top: 7px;\n  }\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  p {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-left: none;\n  border-right: none;\n  display: flex;\n  margin-left: -1.5em;\n  padding: 1em 0 1em 1em;\n  width: calc(100% + 3em);\n\n  a {\n    color: ", ";\n    text-decoration: none;\n  }\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteral(["\n  font-size: 0.8em;\n  color: ", ";\n  margin: 4px 0;\n  overflow: hidden;\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1.875em;\n  margin: 0;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1.5em;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 8px;\n  padding: 1.5em 1.5em;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var font = colors.font,
    primary = colors.primary,
    blue = colors.blue;
var CardContainer = styled.div(_templateObject$2(), primary.border);
var Header = styled.div(_templateObject2$1());
var TitleContainer = styled.div(_templateObject3$1());
var Title = styled.h1(_templateObject4$1());
var Subtitle = styled.span(_templateObject5$1(), font.subtitle);
var HeaderIcon = styled.img(_templateObject6$1());
var LinkContainer = styled.div(_templateObject7$1(), primary.border, blue);
var BodyContainer = styled.div(_templateObject8$1());
var StyledList = styled.ul(_templateObject9$1());

var CompanyCard = function CompanyCard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      website = _ref.website,
      description = _ref.description,
      items = _ref.items;
  return React.createElement(CardContainer, null, React.createElement(Header, null, React.createElement(TitleContainer, null, React.createElement(Title, null, title), React.createElement(Subtitle, null, subtitle)), React.createElement(HeaderIcon, null)), website && React.createElement(LinkContainer, null, React.createElement("a", {
    href: website
  }, toNiceWebsiteFormat(website))), React.createElement(BodyContainer, null, React.createElement("p", null, description), React.createElement(StyledList, null, items.map(function (item) {
    var key = Object.keys(item)[0];
    var value = Object.values(item)[0];
    return React.createElement("li", {
      key: key
    }, React.createElement("strong", null, "".concat(toFirstUpperCase(key), ": ")), React.createElement("span", null, value));
  }))));
};

CompanyCard.propTypes = {
  title: propTypes.string.isRequired,
  subtitle: propTypes.string,
  website: function website(_ref2, propName, componentName) {
    var _website = _ref2.website;

    if (!urlRegexp.test(_website) && _website !== null) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". URL validation failed"));
    }

    return null;
  },
  description: propTypes.string,
  // TODO: Explore items validation like duped keys or format enforcement
  items: propTypes.arrayOf(propTypes.objectOf(propTypes.string))
};
CompanyCard.defaultProps = {
  subtitle: null,
  website: null,
  description: null,
  items: []
};

function _templateObject4$2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  &:hover {\n    ", ";\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n  color: rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var DEFAULT_HOVER_COLOR = colors.black;

var applyRulesIf = function applyRulesIf(condition, rules) {
  return condition ? rules : null;
};

var disabledRules = css(_templateObject$3());

var hoverRules = function hoverRules(color) {
  return css(_templateObject2$2(), color || DEFAULT_HOVER_COLOR);
};

var getDisabledRules = function getDisabledRules(_ref) {
  var disabled = _ref.disabled;
  return applyRulesIf(disabled, disabledRules);
};

var getHoverRules = function getHoverRules(_ref2) {
  var hoverColor = _ref2.hoverColor;
  return hoverRules(hoverColor);
};

var StyledIcon = styled.i(_templateObject3$2(), getDisabledRules, getHoverRules);
var StyledClickableIcon = styled(StyledIcon)(_templateObject4$2());

var ClickableIcon = function ClickableIcon(_ref) {
  var disabled = _ref.disabled,
      hoverColor = _ref.hoverColor,
      name = _ref.name,
      onClick = _ref.onClick;
  return React.createElement(StyledClickableIcon, {
    disabled: disabled,
    className: "material-icons",
    hoverColor: hoverColor,
    onClick: onClick
  }, name);
};

var NormalIcon = function NormalIcon(_ref2) {
  var disabled = _ref2.disabled,
      hoverColor = _ref2.hoverColor,
      name = _ref2.name;
  return React.createElement(StyledIcon, {
    disabled: disabled,
    className: "material-icons",
    hoverColor: hoverColor
  }, name);
};

var Icon = function Icon(props) {
  var onClick = props.onClick;
  return onClick ? React.createElement(ClickableIcon, props) : React.createElement(NormalIcon, props);
};

var iconProps = {
  disabled: propTypes.bool,
  hoverColor: propTypes.string,
  name: propTypes.string.isRequired,
  onClick: propTypes.func
};
Icon.propTypes = iconProps;
NormalIcon.propTypes = _objectSpread({}, iconProps);
ClickableIcon.propTypes = _objectSpread({}, iconProps);
Icon.defaultProps = {
  disabled: false,
  hoverColor: null,
  onClick: null
};

function _templateObject3$3() {
  var data = _taggedTemplateLiteral(["\n  label {\n    text-transform: capitalize;\n    font-weight: bold;\n    margin-right: 0.25em;\n    color: ", ";\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  margin: 0.5em;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var Chips = styled.div(_templateObject$4());
var StyledChip = styled(Chip)(_templateObject2$3());
var Container$1 = styled.div(_templateObject3$3(), colors.primary.tableHead);
var MultiSelect = {
  Chips: Chips,
  StyledChip: StyledChip,
  Container: Container$1
};
var MultiSelectComponent = React.memo(function MultiSelectComponent(_ref) {
  var title = _ref.title,
      options = _ref.options,
      selectedOptions = _ref.selectedOptions,
      setSelectedOptions = _ref.setSelectedOptions;

  var handleChangeMultiple = function handleChangeMultiple(event) {
    event.preventDefault();
    var newSelectedOptions = event.target.value;
    setSelectedOptions(newSelectedOptions);
  };

  return React.createElement(MultiSelect.Container, null, React.createElement(InputLabel, {
    htmlFor: "select-multiple-chip"
  }, title), React.createElement(Select, {
    multiple: true,
    value: selectedOptions,
    onChange: handleChangeMultiple,
    input: React.createElement(Input$1, {
      id: "select-multiple-chip"
    }),
    renderValue: function renderValue(selected) {
      return React.createElement(MultiSelect.Chips, null, selected.map(function (value) {
        return React.createElement(MultiSelect.StyledChip, {
          key: value,
          label: value
        });
      }));
    }
  }, options.map(function (n) {
    return React.createElement(MenuItem, {
      key: n,
      value: n
    }, n);
  })));
});
MultiSelectComponent.propTypes = {
  options: propTypes.arrayOf(propTypes.string),
  title: propTypes.string,
  selectedOptions: propTypes.arrayOf(propTypes.string),
  setSelectedOptions: propTypes.func
};
MultiSelectComponent.defaultProps = {
  options: [],
  title: '',
  selectedOptions: [],
  setSelectedOptions: function setSelectedOptions() {}
};

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$2 = styled.div(_templateObject$5());
var Graph = {
  Container: Container$2
};

function convertTriplesToGraph(obj, formatNodes, formatEdges) {
  var heads = obj.head.vars; // Let's treat the heads variable as s,p,o depending on the order and regardless of actual value

  var s = heads[0];
  var p = heads[1];
  var o = heads[2];
  var graph = obj.results.bindings;
  var ocurrenceMap = new Map();
  var nodes = [];
  var edges = [];
  graph.forEach(function (element) {
    var sValue = element[s].value;
    var formattedNode = formatNodes(sValue);

    if (!ocurrenceMap.has(sValue)) {
      ocurrenceMap.set(sValue, true);
      nodes.push(_objectSpread({}, element, {
        id: sValue,
        label: formattedNode
      }));
    }

    var oValue = element[o].value;
    formattedNode = formatNodes(oValue);

    if (!ocurrenceMap.has(oValue)) {
      ocurrenceMap.set(oValue, true);
      nodes.push(_objectSpread({}, element, {
        id: oValue,
        label: formattedNode
      }));
    }

    edges.push({
      from: element[s].value,
      to: element[o].value,
      label: formatEdges(element[p].value)
    });
  });
  return {
    nodes: nodes,
    edges: edges
  };
}

function NetworkGraphComponent(_ref) {
  var nodes = _ref.nodes,
      edges = _ref.edges,
      triples = _ref.triples,
      formatNodes = _ref.formatNodes,
      formatEdges = _ref.formatEdges,
      options = _ref.options,
      onNodeClick = _ref.onNodeClick;
  useEffect(function () {
    // If the object triples is provided the component will use the generated node and edges from it
    // otherwise, it will use the nodes and edges provided via props
    var graph = triples ? convertTriplesToGraph(triples, formatNodes, formatEdges) : null;
    var nodesC = new DataSet(triples ? graph.nodes : nodes);
    var edgesC = new DataSet(triples ? graph.edges : edges);
    var data = {
      nodes: nodesC,
      edges: edgesC
    }; // eslint-disable-next-line no-undef

    var container = document.getElementById('graphRoot'); // eslint-disable-next-line no-unused-vars

    var network = new Network(container, data, options);
    network.on('selectNode', function (params) {
      if (params.nodes.length === 1) {
        var node = nodesC.get(params.nodes[0]);
        onNodeClick(node);
      }
    });
  }, [triples, formatNodes, formatEdges, nodes, edges, onNodeClick, options]);
  return React.createElement(Graph.Container, {
    id: "graphRoot"
  });
}

NetworkGraphComponent.propTypes = {
  nodes: propTypes.arrayOf(propTypes.shape({
    id: propTypes.number,
    label: propTypes.string
  })),
  edges: propTypes.arrayOf(propTypes.shape({
    from: propTypes.string,
    to: propTypes.string
  })),
  triples: propTypes.shape({
    head: propTypes.shape({
      vars: propTypes.arrayOf(propTypes.string)
    }),
    results: propTypes.shape({
      bindings: propTypes.arrayOf(propTypes.object)
    })
  }),
  formatNodes: propTypes.func,
  formatEdges: propTypes.func,
  onNodeClick: propTypes.func,
  options: propTypes.shape({
    autoResize: propTypes.bool,
    height: propTypes.string,
    width: propTypes.string,
    locale: propTypes.string,
    locales: propTypes.object,
    clickToUse: propTypes.bool,
    configure: propTypes.object,
    edges: propTypes.object,
    nodes: propTypes.object,
    groups: propTypes.object,
    layout: propTypes.object,
    interaction: propTypes.object,
    manipulation: propTypes.object,
    physics: propTypes.object
  })
};
NetworkGraphComponent.defaultProps = {
  nodes: [],
  edges: [],
  triples: null,
  formatNodes: function formatNodes(n) {
    return n;
  },
  formatEdges: function formatEdges(e) {
    return e;
  },
  onNodeClick: function onNodeClick() {},
  options: {}
};

function _templateObject7$2() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  cursor: pointer;\n\n  :hover {\n    background-color: ", ";\n  }\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  list-style: none;\n  max-height: 250px;\n  overflow-y: scroll;\n  border: 1px solid ", ";\n  padding: 0;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteral(["\n  font: inherit;\n  color: currentColor;\n  width: 100%;\n  border: 0;\n  margin: 0;\n  padding: 6px 0 7px;\n  display: block;\n  min-width: 0;\n  box-sizing: content-box;\n  background: none;\n  -webkit-tap-highlight-color: transparent;\n  transition: width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  padding-top: 8px;\n  padding-left: 80px;\n  padding-right: 8px;\n  padding-bottom: 8px;\n\n  :focus {\n    outline: none;\n  }\n\n  ::placeholder {\n    color: ", ";\n    opacity: 0.7;\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 72px;\n  display: flex;\n  position: absolute;\n  align-items: center;\n  pointer-events: none;\n  justify-content: center;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  width: 100%;\n  position: relative;\n  margin-left: 0;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.15);\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$3 = styled.div(_templateObject$6(), function (props) {
  return props.fontColor;
});
var IconContainer = styled.div(_templateObject2$4());
var InputContainer = styled.div(_templateObject3$4());
var Input = styled.input(_templateObject4$3(), function (props) {
  return props.fontColor;
});
var Header$1 = styled.div(_templateObject5$2());
var SuggestionList = styled.ul(_templateObject6$2(), function (props) {
  return props.isVisible ? 'block' : 'none';
}, colors.primary.border);
var SuggestionItem = styled.li(_templateObject7$2(), function (props) {
  return props.hoverBg;
});
var SearchBar = {
  Container: Container$3,
  IconContainer: IconContainer,
  InputContainer: InputContainer,
  Input: Input,
  SuggestionItem: SuggestionItem,
  SuggestionList: SuggestionList,
  Header: Header$1
};

var SearchBarComponent = function SearchBarComponent(_ref) {
  var fontColor = _ref.fontColor,
      hoverBg = _ref.hoverBg,
      onSubmit = _ref.onSubmit,
      placeholderText = _ref.placeholderText,
      asyncSearchFn = _ref.asyncSearchFn,
      filteringFn = _ref.filteringFn,
      debounceDelay = _ref.debounceDelay,
      onSelect = _ref.onSelect;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSelected = _useState4[0],
      setSelected = _useState4[1];

  var _useDebounce = useDebounce(searchText, debounceDelay),
      _useDebounce2 = _slicedToArray(_useDebounce, 1),
      debouncedText = _useDebounce2[0];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      resultArray = _useState6[0],
      setResultArray = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      filteredArray = _useState8[0],
      setFilteredArray = _useState8[1];

  useEffect(function () {
    var fetchData =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return asyncSearchFn(debouncedText);

              case 2:
                result = _context.sent;
                setResultArray(result);
                setFilteredArray(filteringFn(result));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    if (debouncedText.length > 0) {
      fetchData();
    }
  }, [debouncedText, filteringFn, asyncSearchFn]);

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    onSubmit(searchText);
  };

  var handleChange = function handleChange(e) {
    setSearchText(e.target.value);
  };

  var onSelectOption = function onSelectOption(selectedOption) {
    setSearchText(selectedOption);
    onSelect(selectedOption, resultArray);
  };

  return React.createElement(SearchBar.Container, {
    fontColor: fontColor
  }, React.createElement(SearchBar.Header, null, React.createElement(SearchBar.IconContainer, null, React.createElement(Icon, {
    hoverColor: fontColor,
    name: "search"
  })), React.createElement(SearchBar.InputContainer, null, React.createElement("form", {
    onSubmit: handleSubmit
  }, React.createElement(SearchBar.Input, {
    type: "text",
    placeholder: placeholderText,
    fontColor: fontColor,
    value: searchText,
    onChange: handleChange,
    tabIndex: 0,
    onFocus: function onFocus() {
      return setSelected(true);
    },
    onBlur: function onBlur() {
      return setSelected(false);
    }
  })))), filteredArray && filteredArray.length > 0 && React.createElement(SearchBar.SuggestionList, {
    isVisible: isSelected
  }, filteredArray.map(function (r) {
    return React.createElement(SearchBar.SuggestionItem, {
      hoverBg: hoverBg,
      onMouseDown: function onMouseDown() {
        return onSelectOption(r);
      }
    }, r);
  })));
};

SearchBarComponent.propTypes = {
  fontColor: propTypes.string,
  onSubmit: propTypes.func,
  placeholderText: propTypes.string,
  asyncSearchFn: propTypes.func,
  filteringFn: propTypes.func,
  hoverBg: propTypes.string,
  debounceDelay: propTypes.number,
  onSelect: propTypes.func
};
SearchBarComponent.defaultProps = {
  onSubmit: function onSubmit() {},
  fontColor: colors.font.main,
  hoverBg: colors.primary.border,
  placeholderText: 'Search...',
  asyncSearchFn: function asyncSearchFn() {
    return [];
  },
  filteringFn: function filteringFn(e) {
    return e;
  },
  debounceDelay: 200,
  onSelect: function onSelect(r) {
    return r;
  }
};

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em 1em;\n  border-left: 3px solid ", ";\n  height: 2em;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  text-decoration: none;\n  color: black;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  max-height: 500px;\n  overflow-y: scroll;\n  justify-content: space-between;\n"]);

  _templateObject9$2 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$2() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: 16px;\n  background-color: ", ";\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 1em;\n"]);

  _templateObject8$2 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0.5em 0 0 0;\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  font-weight: bold;\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  min-width: 400px;\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$4() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  flex-basis: 600px;\n  flex-grow: 1;\n  cursor: pointer;\n  color: ", ";\n  background-color: ", ";\n\n  :hover {\n    background-color: rgba(245, 245, 245);\n  }\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: bold;\n  font-size: 1.25em;\n  font-size: 1.25em;\n  display: flex;\n  padding: 0 2.3em 1em 2.3em;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  width: 500px;\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$4 = styled.div(_templateObject$7());
var Heading$1 = styled.th(_templateObject2$5(), function (props) {
  return props.color;
});
var Table$1 = styled.table(_templateObject3$5());
var Row$1 = styled.tr(_templateObject4$4(), function (props) {
  return props.color;
}, function (props) {
  return props.isActive ? 'rgba(245, 245, 245)' : null;
});
var Data$1 = styled.td(_templateObject5$3());
var SignalType$1 = styled.div(_templateObject6$3());
var Bubbles$1 = styled.ul(_templateObject7$3());
var Bubble$1 = styled.li(_templateObject8$2(), function (props) {
  return props.color;
});
var Body = styled.tbody(_templateObject9$2());
var Headline$1 = styled.a(_templateObject10(), function (props) {
  return props.color;
});
var SidelineTable = {
  Container: Container$4,
  Heading: Heading$1,
  Table: Table$1,
  Row: Row$1,
  SignalType: SignalType$1,
  Bubbles: Bubbles$1,
  Bubble: Bubble$1,
  Data: Data$1,
  Headline: Headline$1,
  Body: Body
};

function SidelineTableComponent(_ref) {
  var tableTitleColor = _ref.tableTitleColor,
      title = _ref.title,
      colors = _ref.colors,
      listColor = _ref.listColor,
      tableCollection = _ref.tableCollection,
      linesOptions = _ref.linesOptions,
      lineSelector = _ref.lineSelector,
      groupBySelector = _ref.groupBySelector,
      valueSelector = _ref.valueSelector,
      hrefSelector = _ref.hrefSelector,
      selectedOptions = _ref.selectedOptions,
      rdfObj = _ref.rdfObj;
  var df = rdfObj ? getDataFrame(rdfObj) : null;

  var getTableCollection = function getTableCollection() {
    if (tableCollection && !rdfObj) return tableCollection;
    return df.select(groupBySelector, hrefSelector, lineSelector, valueSelector, 'date').groupBy(groupBySelector).filter(function (row) {
      return selectedOptions.includes(row.get(groupBySelector));
    }).toCollection();
  };

  var getLines = function getLines() {
    if (linesOptions && !rdfObj) return linesOptions;
    return df.groupBy(lineSelector).listGroups().map(function (t) {
      return t[lineSelector];
    });
  };

  var table = getTableCollection();
  var linesOptionsArray = getLines();
  return React.createElement(SidelineTable.Table, null, React.createElement("thead", null, React.createElement("tr", null, React.createElement(SidelineTable.Heading, {
    color: tableTitleColor
  }, title))), React.createElement(SidelineTable.Body, null, table.map(function (obj) {
    return React.createElement(SidelineTable.Row, {
      color: listColor
    }, React.createElement(SidelineTable.Data, null, React.createElement(SidelineTable.Headline, {
      color: getColor(obj[lineSelector], linesOptionsArray, colors),
      href: "https://global.factiva.com/redir/default.aspx?P=sa&an=".concat(obj[hrefSelector]),
      target: "_blank"
    }, obj[valueSelector])));
  })));
}

SidelineTableComponent.propTypes = {
  listColor: propTypes.string,
  tableTitleColor: propTypes.string,
  colors: propTypes.string,
  title: propTypes.string,
  // TODO: custom prop validation
  tableCollection: propTypes.arrayOf(propTypes.obj),
  linesOptions: propTypes.arrayOf(propTypes.obj),
  lineSelector: propTypes.string,
  groupBySelector: propTypes.string,
  valueSelector: propTypes.string,
  hrefSelector: propTypes.string,
  selectedOptions: propTypes.arrayOf(propTypes.string),
  rdfObj: propTypes.shape({
    head: propTypes.shape({
      vars: propTypes.arrayOf(propTypes.string)
    }),
    results: propTypes.shape({
      bindings: propTypes.arrayOf(propTypes.object)
    })
  })
};
SidelineTableComponent.defaultProps = {
  groupBySelector: 'type',
  valueSelector: 'title',
  hrefSelector: 'AN',
  lineSelector: 'relatedCompaniesName',
  listColor: colors.font.list,
  tableTitleColor: colors.font.tableHead,
  colors: colors.defaultArray,
  rdfObj: null,
  selectedOptions: [],
  title: null,
  tableCollection: null,
  linesOptions: null
};

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  background-color: rgb(252, 252, 252);\n  padding: 1em;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var Container$5 = styled.div(_templateObject$8());
var Chart = {
  Container: Container$5
};
var ScatterChartComponent = React.memo(function ScatterChartComponent(_ref) {
  var rdfObj = _ref.rdfObj,
      colors = _ref.colors,
      scatterChart = _ref.scatterChart,
      cartesianGrid = _ref.cartesianGrid,
      xAxis = _ref.xAxis,
      yAxis = _ref.yAxis,
      zAxis = _ref.zAxis,
      tooltip = _ref.tooltip,
      legend = _ref.legend,
      scatter = _ref.scatter,
      groupBySelector = _ref.groupBySelector,
      colorSelector = _ref.colorSelector,
      xAxisSelector = _ref.xAxisSelector,
      yAxisSelector = _ref.yAxisSelector,
      zAxisSelector = _ref.zAxisSelector,
      options = _ref.options,
      colorDomain = _ref.colorDomain,
      collection = _ref.collection,
      selectedOptions = _ref.selectedOptions,
      setSelectedOptions = _ref.setSelectedOptions,
      responsiveContainer = _ref.responsiveContainer;

  var formatDate = function formatDate(s) {
    return new Date(s).getTime();
  };

  var getShape = function getShape(type) {
    var shapes = ['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye'];
    return shapes[selectedOptions.indexOf(type)];
  };

  var getTickFormat = function getTickFormat(time) {
    return new Date(time).toLocaleString('en-us', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric'
    });
  };

  var df = rdfObj ? getDataFrame(rdfObj) : null;

  var getOptions = function getOptions() {
    if (options && !rdfObj) return options;
    return df.groupBy(groupBySelector).listGroups().map(function (t) {
      return t[groupBySelector];
    });
  };

  var getColorDomain = function getColorDomain() {
    if (colorDomain && !rdfObj) return colorDomain;
    return df.groupBy(colorSelector).listGroups().map(function (t) {
      return t[colorSelector];
    });
  };

  var getCollection = function getCollection() {
    if (collection && !rdfObj) return collection;
    var groupedDF = df.withColumn('x', function (row) {
      return formatDate(row.get(xAxisSelector));
    }).withColumn('label', function (row) {
      return row.get(colorSelector);
    }).groupBy('x', 'label', groupBySelector); // date and company

    var groupAn = groupedDF.aggregate(function (group) {
      return group.dropDuplicates(yAxisSelector).count();
    }, 'y');
    var groupS = groupedDF.aggregate(function (group) {
      return group.dropDuplicates(zAxisSelector).count();
    }, 'z');
    return groupS.join(groupAn, ['x', 'label', groupBySelector]).filter(function (row) {
      return selectedOptions.includes(row.get(groupBySelector));
    }).groupBy('label', groupBySelector).toCollection();
  };

  var optionsArray = getOptions();
  var colorDomainArray = getColorDomain();
  var collectionDF = getCollection();
  return React.createElement(Chart.Container, null, React.createElement(MultiSelectComponent, {
    title: groupBySelector,
    options: optionsArray,
    selectedOptions: selectedOptions,
    setSelectedOptions: setSelectedOptions
  }), React.createElement(ResponsiveContainer, _extends({
    width: "100%",
    aspect: 4.0 / 1.0
  }, responsiveContainer), React.createElement(ScatterChart, _extends({
    margin: {
      top: 20,
      right: 20,
      bottom: 10,
      left: 10
    }
  }, scatterChart), React.createElement(CartesianGrid, _extends({
    strokeDasharray: "3 3"
  }, cartesianGrid)), React.createElement(XAxis, _extends({
    dataKey: "x",
    name: "Month",
    tickFormatter: function tickFormatter(time) {
      return getTickFormat(time);
    },
    type: "number",
    domain: ['auto', 'auto'],
    tickCount: 3
  }, xAxis)), React.createElement(YAxis, _extends({
    dataKey: "y",
    name: yAxisSelector,
    unit: "",
    orientation: "right",
    label: {
      value: yAxisSelector,
      angle: 90,
      position: 'insideRight'
    },
    allowDecimals: false
  }, yAxis)), React.createElement(ZAxis, _extends({
    dataKey: "z",
    range: [100, 500],
    name: zAxisSelector
  }, zAxis)), React.createElement(Tooltip, _extends({
    cursor: {
      strokeDasharray: '3 3'
    },
    formatter: function formatter(value, name) {
      return name === 'Month' ? getTickFormat(value) : value;
    }
  }, tooltip)), React.createElement(Legend, _extends({
    verticalAlign: "top",
    align: "left",
    height: 60
  }, legend)), collectionDF.map(function (obj) {
    var label = obj.groupKey.label;
    var type = obj.groupKey[groupBySelector];
    return React.createElement(Scatter, _extends({
      name: selectedOptions.length > 1 ? "".concat(label, " - ").concat(type) : "".concat(label),
      data: _toConsumableArray(obj.group.toCollection()),
      fill: getColor(label, colorDomainArray, colors),
      legendType: getShape(type),
      shape: getShape(type)
    }, scatter));
  }))));
});
ScatterChartComponent.propTypes = {
  colors: propTypes.arrayOf(propTypes.string),
  rdfObj: propTypes.shape({
    head: propTypes.shape({
      vars: propTypes.arrayOf(propTypes.string)
    }),
    results: propTypes.shape({
      bindings: propTypes.arrayOf(propTypes.object)
    })
  }),
  cartesianGrid: propTypes.shape(propTypes.object),
  colorDomain: propTypes.arrayOf(propTypes.string),
  colorSelector: propTypes.string,
  groupBySelector: propTypes.string,
  legend: propTypes.shape(propTypes.object),
  options: propTypes.arrayOf(propTypes.string),
  scatter: propTypes.shape(propTypes.object),
  scatterChart: propTypes.shape(propTypes.object),
  selectedOptions: propTypes.arrayOf(propTypes.string),
  setSelectedOptions: propTypes.func,
  tooltip: propTypes.shape(propTypes.object),
  xAxis: propTypes.shape(propTypes.object),
  xAxisSelector: propTypes.string,
  yAxis: propTypes.shape(propTypes.object),
  yAxisSelector: propTypes.string,
  zAxis: propTypes.shape(propTypes.object),
  zAxisSelector: propTypes.string,
  responsiveContainer: propTypes.shape(propTypes.object),
  collection: propTypes.arrayOf(propTypes.shape({
    group: propTypes.object,
    groupKey: propTypes.object
  }))
}; // If it is important to always have the same colors, if not a random color can be generated.

ScatterChartComponent.defaultProps = {
  cartesianGrid: null,
  collection: null,
  colorDomain: null,
  colors: colors.defaultArray,
  colorSelector: 'relatedCompaniesName',
  groupBySelector: 'type',
  legend: null,
  options: null,
  responsiveContainer: null,
  rdfObj: null,
  scatter: null,
  scatterChart: null,
  selectedOptions: [],
  setSelectedOptions: function setSelectedOptions() {},
  tooltip: null,
  xAxis: null,
  xAxisSelector: 'date',
  yAxis: null,
  yAxisSelector: 'AN',
  zAxis: null,
  zAxisSelector: 's'
};
var DEFAULT_THEME = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiGridListTile: {
      root: {
        width: '100%!important'
      }
    }
  }
});

function getTableData(columns, rows, rdfObj, availableColumnNames, dropDuplicatesColumns) {
  var _df$select;

  if (columns && rows && !rdfObj) return {
    rows: rows,
    columns: columns
  };
  var uniqueColumns = availableColumnNames || rdfObj.head.vars;
  var df = getDataFrame(rdfObj);

  var dataTable = (_df$select = df.select.apply(df, _toConsumableArray(uniqueColumns))).dropDuplicates.apply(_df$select, _toConsumableArray(dropDuplicatesColumns));

  return {
    rows: dataTable.toCollection(),
    columns: dataTable.listColumns()
  };
}

var DEFAULT_COLUMN_DICT = {
  title: function title(columnName) {
    return {
      name: columnName,
      label: columnName.toUpperCase(),
      options: {
        filter: false,
        customBodyRender: function customBodyRender(value, tableMeta) {
          var an = tableMeta.rowData[1];
          return React.createElement(Link, {
            href: "https://global.factiva.com/redir/default.aspx?P=sa&an=".concat(an),
            target: "_blank"
          }, value);
        }
      }
    };
  },
  AN: function AN(columnName) {
    return {
      name: columnName,
      label: columnName.toUpperCase(),
      options: {
        display: 'excluded',
        filter: false
      }
    };
  },
  snippet: function snippet(columnName) {
    return {
      name: columnName,
      label: columnName.toUpperCase(),
      options: {
        display: 'false',
        filter: false
      }
    };
  },
  date: function date(columnName) {
    return {
      name: columnName,
      label: columnName.toUpperCase(),
      options: {
        filterList: ['day'],
        filter: true,
        customFilterListRender: function customFilterListRender(v) {
          return "Range: ".concat(v);
        },
        filterType: 'dropdown',
        filterOptions: {
          names: ['day', 'week', 'month', 'year'],
          logic: function logic(date, filters) {
            var currentFilter = filters[0];
            var ref = new Date(date);
            var now = new Date();
            var diffTime = Math.abs(now.getTime() - ref.getTime());
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            switch (currentFilter) {
              case 'day':
                return diffDays > 1;

              case 'week':
                return diffDays > 7;

              case 'month':
                return diffDays > 30;

              case 'year':
                return diffDays > 365;

              default:
                return false;
            }
          }
        },
        customBodyRender: function customBodyRender(value) {
          var date = new Date(value).toLocaleString('default', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
          return React.createElement("time", {
            style: {
              whiteSpace: 'nowrap'
            }
          }, date);
        }
      }
    };
  },
  relatedCompaniesName: function relatedCompaniesName(columnName) {
    return {
      name: columnName,
      label: 'RELATED'
    };
  },
  default: function _default(columnName) {
    return {
      name: columnName,
      label: columnName.toUpperCase()
    };
  }
};

var formatColumn = function formatColumn(c, columnDict) {
  return columnDict[c] ? columnDict[c](c) : columnDict.default(c);
};

function getFormattedColumns(cols) {
  var columnDict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_COLUMN_DICT;
  return cols.map(function (col) {
    return formatColumn(col, columnDict);
  });
}

var defaultOptions = {
  filterType: 'multiselect',
  responsive: 'scroll',
  selectableRows: 'none'
};

function DataTableComponent(_ref) {
  var rdfObj = _ref.rdfObj,
      availableColumnNames = _ref.availableColumnNames,
      dropDuplicatesColumns = _ref.dropDuplicatesColumns,
      columns = _ref.columns,
      rows = _ref.rows,
      title = _ref.title,
      options = _ref.options,
      columnDict = _ref.columnDict,
      theme = _ref.theme;
  var tableData = getTableData(columns, rows, rdfObj, availableColumnNames, dropDuplicatesColumns);
  return React.createElement(MuiThemeProvider, {
    theme: theme
  }, React.createElement(MUIDataTable, {
    title: title,
    data: tableData.rows,
    columns: getFormattedColumns(tableData.columns, columnDict),
    options: _objectSpread({}, defaultOptions, options)
  }));
}

DataTableComponent.propTypes = {
  rdfObj: propTypes.shape({
    head: propTypes.shape({
      vars: propTypes.arrayOf(propTypes.string)
    }),
    results: propTypes.shape({
      bindings: propTypes.arrayOf(propTypes.object)
    })
  }),
  columns: propTypes.arrayOf(propTypes.string),
  availableColumnNames: propTypes.arrayOf(propTypes.string),
  dropDuplicatesColumns: propTypes.arrayOf(propTypes.string),
  rows: propTypes.arrayOf(propTypes.object),
  columnDict: propTypes.shape(propTypes.object),
  title: propTypes.string,
  options: propTypes.shape(propTypes.object),
  theme: propTypes.shape(propTypes.object)
};
DataTableComponent.defaultProps = {
  rdfObj: null,
  columnDict: DEFAULT_COLUMN_DICT,
  theme: DEFAULT_THEME,
  title: '',
  options: null,
  columns: null,
  rows: null,
  availableColumnNames: null,
  dropDuplicatesColumns: []
};

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 2em 1em;\n\n  > div:first-child {\n    width: 100%;\n  }\n\n  li {\n    width: 100%;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var TableContainer = styled.div(_templateObject$9());
var SignalView = {
  TableContainer: TableContainer
};
var SignalView$1 = React.memo(function SignalView$1(_ref) {
  var rdfObj = _ref.rdfObj;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      chartSelectedOptions = _useState2[0],
      setChartSelectedOptions = _useState2[1];

  var formatDate = function formatDate(s) {
    return new Date(s).getTime();
  };

  var df = getDataFrame(rdfObj);
  var dataTable = df.select('type', 'AN', 'date', 'title', 'snippet').dropDuplicates('AN');
  var options = df.groupBy('type').listGroups().map(function (t) {
    return t.type;
  });
  var companies = df.groupBy('relatedCompaniesName').listGroups().map(function (t) {
    return t.relatedCompaniesName;
  });
  var groupedDF = df.withColumn('x', function (row) {
    return formatDate(row.get('date'));
  }).withColumn('label', function (row) {
    return row.get('relatedCompaniesName');
  }).groupBy('x', 'label', 'type'); // date and company

  var groupAn = groupedDF.aggregate(function (group) {
    return group.dropDuplicates('AN').count();
  }, 'y');
  var groupS = groupedDF.aggregate(function (group) {
    return group.dropDuplicates('s').count();
  }, 'z');
  var parsedObj = groupS.join(groupAn, ['x', 'label', 'type']).filter(function (row) {
    return chartSelectedOptions.includes(row.get('type'));
  }).groupBy('label', 'type').toCollection();
  return React.createElement("div", null, React.createElement(ScatterChartComponent, {
    collection: parsedObj,
    colorDomain: companies,
    options: options,
    selectedOptions: chartSelectedOptions,
    setSelectedOptions: setChartSelectedOptions
  }), React.createElement(SignalView.TableContainer, null, React.createElement(DataTableComponent, {
    title: "Events",
    columns: dataTable.listColumns(),
    rows: dataTable.toCollection()
  })));
});
SignalView$1.propTypes = {
  rdfObj: propTypes.shape({
    head: propTypes.shape({
      vars: propTypes.arrayOf(propTypes.string)
    }),
    results: propTypes.shape({
      bindings: propTypes.arrayOf(propTypes.object)
    })
  }).isRequired
};

function _templateObject7$4() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  margin: 0;\n  font-size: 1.5em;\n"]);

  _templateObject7$4 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$4() {
  var data = _taggedTemplateLiteral(["\n  display: table-header-group;\n"]);

  _templateObject6$4 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$4() {
  var data = _taggedTemplateLiteral(["\n  color: rgba(0, 0, 0, 0.54);\n  font-size: 0.8rem;\n  font-weight: 500;\n"]);

  _templateObject5$4 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$5() {
  var data = _taggedTemplateLiteral(["\n  color: inherit;\n  height: 48px;\n  display: table-row;\n  outline: none;\n  vertical-align: middle;\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteral(["\n  display: table-cell;\n  padding: 4px 56px 4px 24px;\n  text-align: left;\n  border-bottom: 1px solid rgba(224, 224, 224, 1);\n  vertical-align: inherit;\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: table;\n  border-spacing: 0;\n  border-collapse: collapse;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 4px;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);\n  min-width: 700px;\n  overflow: auto;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var Container$6 = styled.div(_templateObject$a());
var StyledTable = styled.table(_templateObject2$6());
var Cell = styled.td(_templateObject3$6());
var Row$2 = styled.tr(_templateObject4$5());
var Head = styled(Cell)(_templateObject5$4());
var HeaderRow = styled.thead(_templateObject6$4());
var Title$1 = styled.h6(_templateObject7$4());
var BasicTable = {
  Container: Container$6,
  Head: Head,
  HeaderRow: HeaderRow,
  Row: Row$2,
  StyledTable: StyledTable,
  Cell: Cell,
  Title: Title$1
};

var BasicTableComponent = function BasicTableComponent(_ref) {
  var title = _ref.title,
      heads = _ref.heads,
      body = _ref.body;
  return React.createElement(BasicTable.Container, null, title && React.createElement(BasicTable.Title, null, title), React.createElement(BasicTable.StyledTable, null, React.createElement(BasicTable.HeaderRow, null, React.createElement(BasicTable.Row, null, heads.map(function (head) {
    return React.createElement(BasicTable.Head, {
      key: head
    }, head);
  }))), body.map(function (elem) {
    return React.createElement("tbody", null, React.createElement(BasicTable.Row, null, heads.map(function (head) {
      return React.createElement(BasicTable.Cell, {
        key: elem.id
      }, elem[head] ? elem[head].value : null);
    })));
  })));
};

BasicTableComponent.propTypes = {
  heads: propTypes.arrayOf(propTypes.string),
  body: propTypes.arrayOf(propTypes.objectOf(propTypes.objectOf(propTypes.string || propTypes.number))),
  title: propTypes.string
};
BasicTableComponent.defaultProps = {
  heads: [],
  body: [],
  title: ''
};

function _templateObject3$7() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px;\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 10px;\n  padding-right: 10px;\n  border-right: solid 1px;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n  display:inline-flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var StyledStatsCard = styled(Card)(_templateObject$b());
var StyledValue = styled(Typography)(_templateObject2$7());
var StyledLabel = styled(Typography)(_templateObject3$7());

var StatsCard = function StatsCard(_ref) {
  var label = _ref.label,
      value = _ref.value;
  return React.createElement(StyledStatsCard, null, React.createElement(StyledValue, {
    variant: "h1"
  }, value), React.createElement(StyledLabel, {
    variant: "subtitle1"
  }, label));
};

StatsCard.propTypes = {
  label: propTypes.string.isRequired,
  value: propTypes.string.isRequired
};

function _templateObject3$8() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  -moz-column-count: 2;\n  -webkit-column-count: 2;\n  column-count: 2;\n  text-transform: capitalize;\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var StyledUlOverview = styled('ul')(_templateObject$c());
var StyledUlLinks = styled('ul')(_templateObject2$8());
var StyledTitle = styled(Typography)(_templateObject3$8());

var KeyValueItems = function KeyValueItems(_ref) {
  var content = _ref.content;
  return React.createElement(StyledUlOverview, null, React.createElement(Typography, null, Object.keys(content).map(function (key) {
    return React.createElement("li", {
      key: key
    }, key.split('_').join(' '), ":", content[key].toString(), ' ');
  })));
};

var ArrayItems = function ArrayItems(_ref2) {
  var content = _ref2.content;
  return React.createElement(StyledUlLinks, null, React.createElement(Typography, null, content.map(function (item) {
    return React.createElement("li", {
      key: item.value
    }, item.url ? React.createElement("a", {
      href: item.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, item.value) : item.value);
  })));
};

var Items = function Items(_ref3) {
  var content = _ref3.content;

  if (Array.isArray(content)) {
    return React.createElement(ArrayItems, {
      content: content
    });
  }

  return React.createElement(KeyValueItems, {
    content: content
  });
};

var CollapsibleRow = function CollapsibleRow(_ref4) {
  var title = _ref4.title,
      content = _ref4.content;
  return React.createElement("div", null, React.createElement(ExpansionPanel, null, React.createElement(ExpansionPanelSummary, {
    expandIcon: React.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, React.createElement(StyledTitle, null, title)), React.createElement(ExpansionPanelDetails, null, React.createElement(Items, {
    content: content
  }))));
};

KeyValueItems.propTypes = {
  content: propTypes.objectOf(propTypes.string).isRequired
};
ArrayItems.propTypes = {
  content: propTypes.arrayOf(propTypes.shape({
    value: propTypes.string,
    url: propTypes.string
  })).isRequired
};
Items.propTypes = {
  content: propTypes.node.isRequired
};
CollapsibleRow.propTypes = {
  title: propTypes.string.isRequired,
  content: propTypes.node.isRequired
};

function _templateObject5$5() {
  var data = _taggedTemplateLiteral(["\n  font-family: Exchange !important;\n  color: #3a868b !important;\n  text-aligh: right;\n  padding-bottom: 5px;\n"]);

  _templateObject5$5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  background: rgba(61, 140, 188, 0.15);\n  font-family: Exchange !important;\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$9() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  text-align: left;\n  font-family: Exchange !important;\n"]);

  _templateObject3$9 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  text-align: right;\n  font-family: Exchange !important;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  padding: 1em;\n  font-family: Exchange !important;\n  color: #3a868b !important;\n  text-transform: uppercase;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var StyledEntityTitle = styled(Typography$1)(_templateObject$d());
var StaticHeaderBrand = styled(Typography$1)(_templateObject2$9());
var DetailsSummary = styled(Typography$1)(_templateObject3$9());
var DateArea = styled(Grid)(_templateObject4$6());
var AddToCalendar = styled(Typography$1)(_templateObject5$5());

var InsetHeader = function InsetHeader(_ref) {
  var title = _ref.title;
  return React.createElement(Grid$1, {
    container: true
  }, React.createElement(Grid$1, {
    item: true,
    xs: 6
  }, React.createElement(StyledEntityTitle, {
    variant: "h6"
  }, title)), React.createElement(Grid$1, {
    item: true,
    xs: 6
  }, React.createElement(StaticHeaderBrand, null, "Powered by WSJ Bankruptcy Intelligence")));
};

var AddEventToCalendar = function AddEventToCalendar() {
  return React.createElement(Grid$1, {
    item: true,
    xs: 1
  }, React.createElement(Grid$1, null, React.createElement(EventAvailableIcon, null), React.createElement(AddToCalendar, null, "Add")));
}; // Possible props TBD


var InsetDateDetails = function InsetDateDetails() {
  return React.createElement(Grid$1, {
    item: true,
    xs: 2
  }, React.createElement(DateArea, null, React.createElement(Grid$1, null, "1 Day"), React.createElement(Grid$1, null, "2/6/2020")));
};

var InsetSummary = function InsetSummary(_ref2) {
  var summary = _ref2.summary;
  return React.createElement(Grid$1, {
    container: true
  }, React.createElement(InsetDateDetails, null), React.createElement(Grid$1, {
    item: true,
    xs: 9
  }, React.createElement(DetailsSummary, null, summary)), React.createElement(AddEventToCalendar, null));
};

var RowArea = function RowArea(_ref3) {
  var content = _ref3.content;
  return React.createElement(Grid$1, {
    item: true,
    xs: 12
  }, Object.keys(content).map(function (key) {
    return React.createElement(CollapsibleRow, {
      title: key.split('_').join(' '),
      content: content[key]
    });
  }));
};

var Inset = function Inset(_ref4) {
  var attributes = _ref4.attributes;
  return React.createElement("div", null, React.createElement(Grid$1, {
    container: true
  }, React.createElement(InsetHeader, {
    title: attributes.name
  }), React.createElement(InsetSummary, {
    summary: attributes.summary
  }), React.createElement(RowArea, {
    content: attributes.content
  })));
};

InsetHeader.propTypes = {
  title: propTypes.string.isRequired
};
InsetSummary.propTypes = {
  summary: propTypes.string.isRequired
};
Inset.propTypes = {
  attributes: propTypes.objectOf(propTypes.shape({
    name: propTypes.object,
    summary: propTypes.object,
    content: propTypes.object
  })).isRequired
};
RowArea.propTypes = {
  content: propTypes.node.isRequired
};
export { BasicTableComponent as BasicTable, BubbleTableComponent as BubbleTable, Button, CollapsibleRow, CompanyCard, DataTableComponent as DataTable, Icon, Inset, MultiSelectComponent as MultiSelect, NetworkGraphComponent as NetworkGraph, ScatterChartComponent as ScatterChart, SearchBarComponent as SearchBar, SidelineTableComponent as SidelineTable, SignalView$1 as SignalView, StatsCard };